import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Badge } from 'react-bootstrap';
import { DragIndicator, Close } from '@mui/icons-material';
import type { ColumnSchema } from '../../types/customReport';
import { useTranslation } from 'react-i18next';

interface Props {
  column: ColumnSchema;
  onRemove: () => void;
}

const DraggableColumn: React.FC<Props> = ({ column, onRemove }) => {
  const { t } = useTranslation('pages');
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.key });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="d-flex justify-content-between align-items-center p-2 mb-2 bg-white border rounded shadow-sm"
    >
      <div className="d-flex align-items-center flex-grow-1" {...attributes} {...listeners} style={{ cursor: 'grab' }}>
        <DragIndicator className="text-muted me-2" style={{ fontSize: '20px' }} />
        <span className="me-2">{column.label}</span>
        <Badge bg="light" text="dark" className="border fw-normal" style={{ fontSize: '0.7rem' }}>
          {t(`customReports.columnTypes.${column.type}`)}
        </Badge>
      </div>
      <Button
        variant="link"
        size="sm"
        className="text-danger p-0"
        onClick={onRemove}
      >
        <Close style={{ fontSize: '18px' }} />
      </Button>
    </div>
  );
};

export default DraggableColumn;

